import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgBase, space4, space2 } = theme();

  return StyleSheet.create({
    container: {
      backgroundColor: colorBgBase,
      flexGrow: 0,
      flexShrink: 0,
    },
    contentContainer: {
      flexGrow: 1,
      paddingHorizontal: space4,
      paddingVertical: space2,
    },
    contentContainerLarge: {
      justifyContent: "center",
    },
    contentContainerMedium: {
      justifyContent: "center",
    },
    contentContainerSmall: {
      justifyContent: "flex-start",
    },
  });
};

export { style };
